import { create } from 'zustand';
import useLoadingStore from './use-loading';
import { mapToOptions } from 'utils/mapper';
import { makeRequest } from 'api/api-client';
import { HTTP } from 'constants/http-method';
import { API_ENDPOINTS } from 'api/endpoints';

const useStaffMemberDocuments = create((set) => ({
  documents: [],
  categories: [],
  pagination: {
    pageSize: 10,
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
  },

  // Function to get documents category
  getDocumentsCategory: async ({ successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.GET,
        API_ENDPOINTS.GET_DOCUMENTS_CATEGORY
      );
      if (response.success) {
        set({
          categories:
            mapToOptions(response.data?.data, {
              value: 'id',
              label: 'categoryName',
            }) || [],
        });
        successCallback && successCallback();
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to get documents
  getDocuments: async ({ id, query = null, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.GET,
        API_ENDPOINTS.GET_CAREGIVER_DOCUMENTS,
        null,
        query,
        id
      );

      if (response.success) {
        set({
          documents: response.data?.data || [],
          pagination: {
            pageSize: response.data?.pagination?.limit,
            totalItems: response.data?.pagination?.total,
            currentPage: response.data?.pagination?.page,
            totalPages: response.data?.pagination?.totalPages,
          },
        });
        successCallback && successCallback();
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to add the document
  addDocument: async ({ data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.POST,
        API_ENDPOINTS.ADD_CAREGIVER_DOCUMENT,
        data
      );

      if (response.success) {
        await useStaffMemberDocuments.getState().getDocuments({
          id: data.userId,
          successCallback: () => {
            useStaffMemberDocuments.getState().resetCurrentPage(); // Reset page
          },
        });
        successCallback && successCallback(response);
      }

      // if (response.success) {
      //   successCallback && successCallback(response);
      // }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to delete the document
  deleteDocument: async ({ id, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.DELETE,
        API_ENDPOINTS.DELETE_CAREGIVER_DOCUMENT,
        null,
        null,
        id
      );

      if (response.success) {
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to update the document
  updateDocument: async ({ id, data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.PUT,
        API_ENDPOINTS.UPDATE_CAREGIVER_DOCUMENT,
        data,
        null,
        id
      );

      if (response.success) {
        await useStaffMemberDocuments.getState().getDocuments({
          id: data.userId,
          successCallback: () => {
            useStaffMemberDocuments.getState().resetCurrentPage(); // Reset page
          },
        });
        successCallback && successCallback(response);
      }

      // if (response.success) {
      //   successCallback && successCallback(response);
      // }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to toggle the status of document
  toggleStatusOfDocument: async ({ id, data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.PUT,
        API_ENDPOINTS.TOGGLE_STATUS_DOCUMENT,
        data,
        null,
        id
      );

      if (response.success) {
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },
}));

export default useStaffMemberDocuments;
